<template>
    <div class="card">
        <div class="card-header text-black p-2 bg-warning bg-opacity-75">
            <div class="d-flex justify-content-between align-items-center">
                <span>Overdue Tasks({{ this.momentObj(serviceDate).format('D MMM, YYYY')}})</span>
                <div class="d-flex gap-1">
                    <input 
                        v-model="search" 
                        type="text" 
                        name="search"
                        id="search"
                        class="form-control form-control-sm"
                        placeholder="Search..." 
                        autocomplete="off"
                    >
                    <!-- <PreviousDateIcon v-model="serviceDate" />
                    <NextDateIcon v-model="serviceDate" />
                    <CalendarIcon v-model="serviceDate" :auto-apply="true" /> -->
                </div>
            </div>
        </div>
        <div class="card-body overflow-auto p-2" style="height: 200px;">
            <div class="table-responsive">
                <table class="table hm-fs-12 align-middle table-hover table-sm">
                    <thead>
                        <tr>
                            <th scope="col" class="bg-theme">Handyman</th>
                            <th scope="col" class="bg-theme">Client</th>
                            <th scope="col" class="bg-theme">Address</th>
                            <th scope="col" class="bg-theme" width="80px">Post Code</th>
                            <th scope="col" class="bg-theme">Phone</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr
                            v-if="filteredOrders.length > 0"
                            v-for="order in filteredOrders"
                            :key="order.id"
                            class="cursor-pointer"
                            @contextmenu.prevent.stop="showContextMenu($event, order)"
                        >
                            <td :title="order.customer.name">
                                {{
                                    order?.handymans?.map(item => {
                                        return formatName(item?.name)
                                    }).join(', ')
                                }}
                            </td>
                            <td>{{ formatName(order.customer.name) }}</td>
                            <td>{{ order.address.address + ', ' + order.address.address_1 }}</td>
                            <td>{{ order.address.postal_code }}</td>
                            <td>{{ order.customer.phone_number }}</td>
                        </tr>
                        <tr v-else-if="processing">
                            <td colspan="5" class="text-center">
                                <Loader />
                            </td>
                        </tr>
                        <tr v-else>
                            <td colspan="5" class="text-center">No orders found</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>

    <!-- Right click context -->
    <vue-simple-context-menu
        element-id="handleRightClickOverDueTasks"
        :options="contextMenuOptions"
        ref="rightClickMenu"
        @option-clicked="handleRightClickMenuAction"
    >
    </vue-simple-context-menu>

    <!-- Customer Details Modal -->
    <CustomerDetails
        v-if="selectedOrder"
        ref="customerDetails" 
        :order="selectedOrder" 
    />

    <!-- Add Attachment Modal -->
    <AddAttachment
        v-if="selectedOrder"
        ref="addAttachmentModal"
        :orderId="selectedOrder.id"
    />

    <!-- Move order to pending -->
    <MoveToPending
        v-if="selectedOrder"
        ref="moveToPendingModal"
        :order="selectedOrder"
    />

    <!-- Move order to processing -->
    <MoveToProcessing
        v-if="selectedOrder"
        ref="moveToProcessingModal"
        :order="selectedOrder"
    />

    <!-- Cancel Order Modal -->
    <CancelOrder
        v-if="selectedOrder"
        ref="cancelOrderModal"
        :order="selectedOrder"
    />

    <!-- Assign Order Modal -->
    <AssignOrder
        v-if="selectedOrder"
        ref="assignOrderModal"
        :order="selectedOrder"
        :action="assignOrReassign"
    />

    <!-- Quotation Modal -->
    <Quotation
        v-if="selectedOrder"
        ref="quotationModal"
        :order="selectedOrder"
        :action="action"
    />

    <!-- Update Order Status Modal -->
    <UpdateOrderStatus
        v-if="selectedOrder"
        ref="updateOrderStatusModal"
        :order="selectedOrder"
        :action="action"
    />

    <!-- Move order to completed -->
    <MoveToCompleted
        v-if="selectedOrder"
        ref="moveToCompletedModal"
        :order="selectedOrder"
    />

</template>

<script>
import VueSimpleContextMenu from "vue-simple-context-menu";
import "vue-simple-context-menu/dist/vue-simple-context-menu.css";

import { appMixin } from '../../mixin/appMixin';
import Loader from '../partials/Loader';
import CalendarIcon from '../partials/CalendarIcon';
import NextDateIcon from '../partials/NextDateIcon';
import PreviousDateIcon from '../partials/PreviousDateIcon';

import CustomerDetails from "../Order/CustomerDetails.vue";
import AddAttachment from "../Order/AddAttachment.vue";
import CancelOrder from "../Order/CancelOrder.vue";
import AssignOrder from "../Order/AssignOrder.vue";
import MoveToProcessing from "../Order/MoveToProcessing.vue";
import MoveToPending from "../Order/MoveToPending.vue";
import Quotation from "../Order/Quotation.vue";
import UpdateOrderStatus from "../Order/UpdateOrderStatus.vue";
import MoveToCompleted from "../Order/MoveToCompleted.vue";

export default {
    name: "OverdueTasks",
    mixins: [appMixin],
    components: {
        Loader,
        CalendarIcon,
        NextDateIcon,
        PreviousDateIcon,
        VueSimpleContextMenu,
        CustomerDetails,
        AddAttachment,
        CancelOrder,
        AssignOrder,
        MoveToProcessing,
        MoveToPending,
        Quotation,
        UpdateOrderStatus,
        MoveToCompleted,
    },
    data() {
        return {
            orders: [],
            processing: true,
            search: '',
            serviceDate: this.momentObj(new Date()),
            assignOrReassign: '',
            selectedOrder: null,
            contextMenuOptions: [],
            availableOptions: {
                pending: [
                    {name: "Move To Assigned", action: "move_to_assigned"},
                    {name: "View Order", action: "order_view" },
                    {name: "View Customer", action: "view_customer" },
                    {name: "Add Attachment", action: "add_attachment" },
                    {name: "Cancel Order", action: "cancel" },
                    //{name: "Duplicate Order", action: "duplicate" },
                ],
                assigned: [
                    {name: "Back To Pending", action: "move_to_pending"},
                    {name: "Move To Processing", action: "move_to_processing"},
                    {name: "View Order", action: "order_view" },
                    {name: "View Customer", action: "view_customer" },
                    {name: "Add Attachment", action: "add_attachment" },
                    {name: "Reassign Order", action: "reassign_order" },
                    {name: "Cancel Order", action: "cancel" },
                    //{name: "Duplicate Order", action: "duplicate" },
                ],
                processing: [
                    {name: "Back To Pending", action: "move_to_pending"},
                    {name: "Back To Assigned", action: "move_to_assigned"},
                    {name: "Move To Quotation", action: "move_to_quotation"},
                    {name: "Move To Completed", action: "move_to_completed"},
                    {name: "View Order", action: "order_view" },
                    {name: "View Customer", action: "view_customer" },
                    {name: "Add Attachment", action: "add_attachment" },
                    {name: "Cancel Order", action: "cancel" },
                    //{name: "Duplicate Order", action: "duplicate" },
                ],
                quotation: [
                    {name: "Back To Processing", action: "move_to_processing"},
                    {name: "Move To Completed", action: "move_to_completed"},
                    {name: "Quotation Declined", action: "quotation_declined"},
                    {name: "Quotation Approved", action: "quotation_approved"},
                    {name: "View Order", action: "order_view" },
                    {name: "View Customer", action: "view_customer" },
                    {name: "Add Attachment", action: "add_attachment" },
                    {name: "Cancel Order", action: "cancel" },
                    //{name: "Duplicate Order", action: "duplicate" },
                ],
                engineer_completed: [
                    {name: "Move To Completed", action: "move_to_completed"},
                    {name: "Move To Quotation", action: "move_to_quotation"},
                    {name: "Back To Processing", action: "move_to_processing"},
                    {name: "View Order", action: "order_view" },
                    {name: "View Customer", action: "view_customer" },
                    {name: "Add Attachment", action: "add_attachment" },
                    {name: "Cancel Order", action: "cancel" },
                    //{name: "Duplicate Order", action: "duplicate" },
                ]
            }
        }
    },
    mounted() {
        this.getOrders();

        this.$emitter.on('reset-selected-order', () => {
            this.selectedOrder = null;
        });

        this.$emitter.on('refresh-order-list', (data) => {
            this.getOrders();
        });
    },
    computed: {
        filteredOrders() {
            // Search in the following
            // Fields: order.order_number,order.address.full_address,
            // order.customer.name,order.customer.email,order.customer.phone_number
            return this.orders.filter(order => {
                return order.order_number.toLowerCase().includes(this.search.toLowerCase()) ||
                    order.address.full_address.toLowerCase().includes(this.search.toLowerCase()) ||
                    order.customer.name.toLowerCase().includes(this.search.toLowerCase()) ||
                    order.customer.email.toLowerCase().includes(this.search.toLowerCase()) ||
                    order.customer.phone_number.toLowerCase().includes(this.search.toLowerCase());
            });
        }
    },
    watch: {
        serviceDate() {
            this.getOrders();
        }
    },
    methods: {
        getOrders() {
            this.processing = true;
            axios.post('/api/admin/orders/overdue-tasks', {
                service_date: this.serviceDate
            })
                .then(response => {
                    this.orders = response.data.orders;
                    this.processing = false;
                })
                .catch(error => {
                    console.error(error);
                    this.processing = false;
                });
        },
        showContextMenu(event, order) {
            console.log(order);
            //this.selectedOrder = order;
            this.contextMenuOptions = this.availableOptions[order.status];
            this.$refs.rightClickMenu.showMenu(event, order)
        },
        handleRightClickMenuAction(event) {
            let order = event.item;
            let action = event.option.action;
            this.selectedOrder = order;

            // Check if action is valid
            if (!action) {
                return;
            }

            // If action is view_order then view order
            if (action === 'order_view') {
                window.location.href = "/admin/orders/" + order.order_number;
                return;
            }
            else if(action === 'view_customer') {
                this.$nextTick(() => {
                    if (this.$refs.customerDetails) {
                        this.$refs.customerDetails.showModal();
                    }
                });
                return;
            }
            else if(action === 'add_attachment') {
                this.$nextTick(() => {
                    if (this.$refs.addAttachmentModal) {
                        this.$refs.addAttachmentModal.showModal();
                    }
                });
                return;
            }
            else if(action === 'move_to_assigned') {
                this.assignOrReassign = 'assign';
                this.$nextTick(() => {
                    if (this.$refs.assignOrderModal) {
                        this.$refs.assignOrderModal.showModal();
                    }
                });
                return;
            }
            else if(action === 'reassign_order') {
                this.assignOrReassign = 'reassign';
                this.$nextTick(() => {
                    if (this.$refs.assignOrderModal) {
                        this.$refs.assignOrderModal.showModal();
                    }
                });
                return;
            }
            else if(action === 'move_to_pending') {
                this.$nextTick(() => {
                    if (this.$refs.moveToPendingModal) {
                        this.$refs.moveToPendingModal.showModal();
                    }
                });
                return;
            }
            else if(action === 'move_to_processing') {
                this.$nextTick(() => {
                    if (this.$refs.moveToProcessingModal) {
                        this.$refs.moveToProcessingModal.showModal();
                    }
                });
                return;
            }
            else if(action === 'move_to_quotation') {
                this.$nextTick(() => {
                    if (this.$refs.quotationModal) {
                        this.action = 'move_to_quotation';
                        this.$refs.quotationModal.showModal();
                    }
                });
                return;
            }
            else if(action === 'quotation_declined') {
                this.$nextTick(() => {
                    if (this.$refs.quotationModal) {
                        this.action = 'quotation_declined';
                        this.$refs.quotationModal.showModal();
                    }
                });
                return;
            }
            else if(action === 'quotation_approved') {
                this.$nextTick(() => {
                    if (this.$refs.updateOrderStatusModal) {
                        this.action = 'quotation_approved';
                        this.$refs.updateOrderStatusModal.showModal();
                    }
                });
                return;
            }
            else if(action === 'move_to_completed') {
                this.$nextTick(() => {
                    if (this.$refs.moveToCompletedModal) {
                        this.$refs.moveToCompletedModal.showModal();
                    }
                });
                return;
            }
            else if(action === 'duplicate') {
                this.$nextTick(() => {
                    if (this.$refs.duplicateOrderModal) {
                        this.$refs.duplicateOrderModal.showModal();
                    }
                });
                return;
            }
            else if(action === 'cancel') {
                this.$nextTick(() => {
                    if (this.$refs.cancelOrderModal) {
                        this.$refs.cancelOrderModal.showModal();
                    }
                });
                return;
            }
        }
    }
}
</script>